import { Component, OnInit } from '@angular/core';
import { ServiceApi } from '../../api/service.api';
import { ConfigInternalService } from '../../services/config-internal.service';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { ServiceVirtualReceptionEntity } from '../../entities/service.virtualreception.entity';
import { TemporaryServiceVirtualReceptionEntity } from '../../entities/temporary.service.virtualreception.entity';
@Component({
  selector: 'app-inspra-configuration',
  templateUrl: './inspra-configuration.component.html',
  styleUrls: ['./inspra-configuration.component.scss']
  
})
export class InspraConfigurationComponent implements OnInit {
  service_id: any;
  ocms_plan: any = null
  current_date:any
  virtual_reception: any 
  show_service_detail_configuration = true;
  show_primary_recipient_configuration = false;
  show_additional_departments_configuration = false;
  show_personalize_greetings_configuration = false;
  show_signoff_configuration = false;
  show_email_subject_configuration = false;
  show_advance_configuration = false;
  show_slider: boolean = false
  showConnectionListModal: boolean = false
  submit_success: any
  show_reset_change_notification: any = ""
  error_message = '';
  connection_destination_type = 'email';
  // virtual_reception: any = {
  //   service_reference: 'Phone answering - testing',
  //   indial_number: '61370533850',
  //   plan: 'Phone Answering - Testing',
  //   service_status: 'Active',
  //   category_name: 'PHONE ANSWERING',
  //   created: '2026-02-01',
  //   cancellation_date: '',
  //   connection_type: 'Alltel Transfer'
  // };

  constructor(
    private service_api: ServiceApi, 
    public internal_config: ConfigInternalService, 
    private location: Location, 
    private route: ActivatedRoute, 
    public router: Router,
  ) {}

  ngOnInit(){
    this.service_id = this.route.snapshot.paramMap.get('service_id')

    this.getInspraService()
    this.virtual_reception = new ServiceVirtualReceptionEntity()
    this.getVirtualReceptionServiceDetails()
  }

  showSlider() {
    this.show_slider = true
  }

  goBack(){
      this.show_slider = false
      this.show_primary_recipient_configuration = false
      this.show_personalize_greetings_configuration = false
      this.show_email_subject_configuration = false
      this.show_primary_recipient_configuration = false
      this.show_signoff_configuration = false
      this.getInspraService()
      // this.getVirtualReceptionServiceDetails()
  }
  showPrimaryRecipientConfiguration() {
    this.show_primary_recipient_configuration =
      !this.show_primary_recipient_configuration;
  }

  showAdditionalDepartmentsConfiguration() {
    this.show_additional_departments_configuration =
      !this.show_additional_departments_configuration;
  }

  showPersonalizeGreetingsConfiguration() {
    this.show_personalize_greetings_configuration =
      !this.show_personalize_greetings_configuration;
  }

  showSignOffConfiguration() {
    this.show_signoff_configuration =
      !this.show_signoff_configuration;
  }

  showEmailSubjectConfiguration() {
    this.show_email_subject_configuration =
      !this.show_email_subject_configuration;
  }

  showAdvanceConfiguration() {
    this.show_advance_configuration =
      !this.show_advance_configuration;
  }

  openConnectionListModal() {
    this.showConnectionListModal = true;
  }

  onBusinessNameChange(businessName: string) {
    this.virtual_reception.greeting_message =
      `Welcome to ${businessName}, you're speaking with Sam, an AI Receptionist. How can I assist?`;

      this.virtual_reception.email_subject =
      `${businessName},You’ve got a new message!`;
  }

  characterLength(str){
    if(str !== null && str !== undefined){
      return str.length;
    }
    return 0;
  }

  vrSaveConfiguration() {
    if (this.virtual_reception.config_module === 'inspraai_ib') {
      this.virtual_reception.connection_list.splice(1, 1);
    }
    const allowedKeys = [
      'indial_number',
      'connection_type',
      'business_name',
      'agent_name',
      'greeting_message',
      'sign_off',
      'additional_questions',
      'connection_list',
      'email_subject',
      'indial_city',
      'order_item_id',
      'comment',
      'transfer_number'
    ];
  
    // const payload = Object.fromEntries(
    //   allowedKeys.map(key => [key, this.virtual_reception[key]])
    // );
    const payload = allowedKeys.reduce((obj, key) => {
      obj[key] = this.virtual_reception[key];
      return obj;
    }, {} as Record<string, any>);
  
    this.internal_config.showGlobalLoader(true);

    this.service_api.saveInspraConfig(payload).subscribe(
      (data: any) => {
        this.internal_config.showGlobalLoader(false);
        this.submit_success = "Configuration was successfully submitted!"
        this.showMessageNotification()
      },
      (error: any) => {
        this.internal_config.showGlobalLoader(false);

        console.error('Error saving configuration', error);
      
        if (error.status === 422 && error.error.errors) {
          // Get the first validation error
          const errors = error.error.errors;
          const firstKey = Object.keys(errors)[0];
          this.error_message = errors[firstKey][0];
        } else {
          this.error_message = 'An unexpected error occurred.';
        }
      
        this.submit_success = false;
        this.showMessageNotification();
      }
    );
  }

  getVirtualReceptionServiceDetails() {

    this.service_api.getServiceDetails(this.service_id).subscribe(
      (data:any) => {
        this.internal_config.showGlobalLoader(false)

        if(data.config_module == 'inspraia' ) {
          this.ocms_plan = true
        }
        else {
          this.ocms_plan = false
        }
      },
      (data:any) => {
        this.internal_config.showGlobalLoader(false)
    })    
    

    this.service_api.getVirtualReceptionServiceDetails(this.service_id).subscribe(

      (data:any) => {
        this.internal_config.showGlobalLoader(false)
        this.virtual_reception.cancellation_date = data.cancellation_actual_date
        this.virtual_reception.plan = data.plan_name
        this.virtual_reception.config_module = data.config_module;
        
        this.virtual_reception.category_name = data.plan_subcategory_name
        this.virtual_reception.created = data.start_date
        this.virtual_reception.service_status = data.cancellation_actual_date == null || data.cancellation_actual_date >= this.current_date ? 'Active' : 'Closed'
        this.virtual_reception.service_reference = data.subscription_reference 
      },
      
      (data:any) => {
        this.internal_config.showGlobalLoader(false)
      })    
  }

  getInspraService() {

    // this.service_api.getScheduledTmcConfig(this.service_id).subscribe(
    //   (data:any) => {
    //     this.scheduled_config=data
    //   }
    // )
    this.internal_config.showGlobalLoader(true);
    this.service_api.getInspraConfig(this.service_id).subscribe(

      (data:any) => {
        this.virtual_reception.indial_number = data.indial_number
        this.virtual_reception.indial_city = data.indial_city
        this.virtual_reception.order_item_id = data.order_item_id
        this.virtual_reception.agent_name = data.agent_name
        this.virtual_reception.additional_questions = data.additional_questions
        this.virtual_reception.email_subject = data.email_subject
        this.virtual_reception.business_name = data.business_name
        this.virtual_reception.greeting_message = data.greeting_message
        this.virtual_reception.connection_type = data.connection_type
        this.virtual_reception.sign_off = data.sign_off
        this.virtual_reception.connection_list = data.connection_list
        this.virtual_reception.personalised_greeting = 1
        this.virtual_reception.personalised_sign_off = data.personalised_sign_off
        this.virtual_reception.greeting_business_name = data.greeting_business_name
        this.virtual_reception.greeting_type = data.personalised_greeting == 1 ? 'personalised' : 'standard'
        // this.virtual_reception.config_module = data.config_module;
        this.virtual_reception.business_hours = data.business_hours
        this.internal_config.showGlobalLoader(false);

      }
    )
  }


  showMessageNotification(){

    setTimeout(()=>{

      if(this.error_message) {

        this.error_message = ""
      }

      if(this.submit_success) {

        this.submit_success = ""
      }
     
    }, 5000);

  }
}